import border from './border';
import text from './text';

export default {
  border,
  text,
};
